__turbopack_context__.v({
  "breadcrumbs": "Breadcrumbs-module-scss-module__Ctq3Cq__breadcrumbs",
  "floating": "Breadcrumbs-module-scss-module__Ctq3Cq__floating",
  "floatingFullWidth": "Breadcrumbs-module-scss-module__Ctq3Cq__floatingFullWidth",
  "floatingRightSection": "Breadcrumbs-module-scss-module__Ctq3Cq__floatingRightSection",
  "floatingWrapper": "Breadcrumbs-module-scss-module__Ctq3Cq__floatingWrapper",
  "fullWidth": "Breadcrumbs-module-scss-module__Ctq3Cq__fullWidth",
  "link": "Breadcrumbs-module-scss-module__Ctq3Cq__link",
  "rightSection": "Breadcrumbs-module-scss-module__Ctq3Cq__rightSection",
  "rightSectionDrawer": "Breadcrumbs-module-scss-module__Ctq3Cq__rightSectionDrawer",
  "root": "Breadcrumbs-module-scss-module__Ctq3Cq__root",
  "sidebarToggle": "Breadcrumbs-module-scss-module__Ctq3Cq__sidebarToggle",
  "sticky": "Breadcrumbs-module-scss-module__Ctq3Cq__sticky",
});
